<script>
import { getAppProps, getAppEvents, getAppData, getAppOptions, dispatchComponentInstance, dataListener, eventsListener, propsListener, optionsListener } from './index.js'
let component
export default {
  name: 'PluginWrapper',
  props: {
    com: {
      type: Object,
      require: true,
      default () {
        return undefined
      }
    }
  },
  data () {
    return {
      comProps: {},
      comEvent: {},
      comData: undefined,
      comOptions: undefined
    }
  },
  created () {
    this.comProps = getAppProps()
    this.comEvent = getAppEvents()
    this.comData = getAppData()
    this.comOptions = getAppOptions()
    dataListener((data) => {
      console.log('[@ccprivate/plugin-engine-saas][plugin-wrapper] dataListener', data)
      this.comData = data
    })
    eventsListener((events) => {
      console.log('[@ccprivate/plugin-engine-saas][plugin-wrapper] eventsListener', events)
      this.comEvent = events
    })
    propsListener((props) => {
      console.log('[@ccprivate/plugin-engine-saas][plugin-wrapper] propsListener', props)
      this.comProps = props
    })
    optionsListener((options) => {
      console.log('[@ccprivate/plugin-engine-saas][plugin-wrapper] optionsListener', options)
      this.comOptions = options
    })
  },
  render (h) {
    component = h(this.com, {
      props: { ...this.comProps, cc_com_data: this.comData, cc_com_options: this.comOptions },
      on: { ...this.comEvent }
    })
    return component
  },
  mounted () {
    dispatchComponentInstance(component.componentInstance)
  }
}
</script>
